export default __webpack_public_path__ + "static/media/vcake.767d9855.png";